var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-column items-center"},[_c('img',{staticClass:"endpostimage",attrs:{"src":"https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/image/1.jpg"}}),_c('span',{staticClass:"endpagetext"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }